
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {

    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/inventory?${queryString}`; 
        return axios.get(url, { headers: authHeader() });
    },

    /* getAll(pageUrl=null) {
        const url = `${API_URL}/inventory?page=${pageUrl}`; 
        return axios.get(url, { headers: authHeader() });
    }, */
    getData(id) {
        return axios.get(`${API_URL}/inventory/${id}`, { headers: authHeader() });
    },
    getFilters() {
        return axios.get(`${API_URL}/inventory/filters`, { headers: authHeader() });
    },
    createData(data) {

        // Obtener el user_id desde el localStorage
        let userId = JSON.parse(localStorage.getItem('user'));

        // Validar el user_id
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }

        data.user_id = userId.id;
        
        return axios.post(`${API_URL}/inventory`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/inventory/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/inventory/${id}`, { headers: authHeader() });
    },

    exportCsv(search = null, semaphore = null) {
        const params = {};
        if (search) params.search = search;
        if (semaphore) params.semaphore = semaphore;
        const queryString = new URLSearchParams(params).toString();
        const url = queryString ? `${API_URL}/inventory/export-csv?${queryString}` : `${API_URL}/inventory/export-csv`;
        return axios.get(url, {
            headers: authHeader(),
            responseType: 'blob',
        });
    },

    exportPdf(filters = {}) {
        const params = {};
        if (filters.search) params.search = filters.search;
        if (filters.semaphore) params.semaphore = filters.semaphore;
        const queryString = new URLSearchParams(params).toString();
        const url = queryString
            ? `${API_URL}/inventory/export-pdf?${queryString}`
            : `${API_URL}/inventory/export-pdf`;
        return axios.get(url, {
            headers: authHeader(),
            responseType: 'blob',
        });
    },

    exportExcel(filters = {}) {
        const params = {};
        if (filters.search) params.search = filters.search;
        if (filters.semaphore) params.semaphore = filters.semaphore;
        const queryString = new URLSearchParams(params).toString();
        const url = queryString
            ? `${API_URL}/inventory/export-excel?${queryString}`
            : `${API_URL}/inventory/export-excel`;
        return axios.get(url, {
            headers: authHeader(),
            responseType: 'blob',
        });
    },

    importCsv(file) {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(`${API_URL}/inventory/import-csv`, formData, {
            headers: {
                Authorization: authHeader().Authorization || '',
            },
        });
    },

    importExcelSaldos(file) {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(`${API_URL}/inventory/import-excel-saldos`, formData, {
            headers: {
                Authorization: authHeader().Authorization || '',
            },
        });
    },

    importMistockExcel(file) {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(`${API_URL}/inventory/import-mistock-excel`, formData, {
            headers: {
                Authorization: authHeader().Authorization || '',
            },
        });
    },

    syncWooCommerce(id) {
        return axios.post(
            `${API_URL}/inventory/${id}/sync-woocommerce`,
            {},
            { headers: authHeader() }
        );
    },

    syncSiigo() {
        return axios.post(
            `${API_URL}/inventory/sync-siigo`,
            {},
            { headers: authHeader() }
        );
    },

    syncKubapp() {
        return axios.post(
            `${API_URL}/inventory/sync-kubapp`,
            {},
            { headers: authHeader() }
        );
    },

    syncShopify(id) {
        return axios.post(
            `${API_URL}/shopify/inventory/${id}/sync`,
            {},
            { headers: authHeader() }
        );
    },

    resetQuantities() {
        return axios.post(
            `${API_URL}/inventory/reset-quantities`,
            {},
            { headers: authHeader() }
        );
    },

    uploadImage(id, file) {
        const formData = new FormData();
        formData.append('image', file);
        return axios.post(`${API_URL}/inventory/${id}/upload-image`, formData, {
            headers: {
                Authorization: authHeader().Authorization || '',
                'Content-Type': 'multipart/form-data',
            },
        });
    },
};